import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { push as Push } from 'redux-first-history';

import { Container, SecondaryButton, TabsPanel } from '@dev/ee-components';
import { safelyDecodeBase64Url } from '@dev/ee-tools';
import { JourneyStatus } from '@dev/ee-api/ee-api-models';
import { AutomationPaths } from '@/services/dictionaries/Paths';
import { ApplicationState } from '@/store';
import { GetAutomationByNameStart } from '@/store/automations/actions';

import useMobile from '@/services/hooks/useMobile';
import { BasicInfo } from './BasicInfo';
import { Performance } from './Performance';
import { WorkflowEmails } from './WorkflowEmails';

import { AutomationReportProps } from './AutomationReportInterface';
import { Preview } from '../Preview';

const AutomationReport: FC<AutomationReportProps> = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isMobile = useMobile();

    const { name } = useParams<{ name: string }>();

    useEffect(() => {
        dispatch(GetAutomationByNameStart(safelyDecodeBase64Url(name), true));
    }, []);

    const { automations } = useSelector((state: ApplicationState) => state);

    return (
        <>
            <Container>
                <TabsPanel
                    breadcrumbs={t('automations')}
                    title={safelyDecodeBase64Url(name)}
                    isMobile={false}
                    additionalHeaderContent={
                        !isMobile && (
                            <SecondaryButton
                                style={{ marginTop: '16px' }}
                                text={t('viewworkflow')}
                                onClick={(): void => {
                                    automations?.singleAutomation.Status === JourneyStatus.Active
                                        ? dispatch(Push(AutomationPaths.AutomationPreview.replace(':name', name)))
                                        : dispatch(Push(AutomationPaths.AutomationEditor.replace(':name', name)));
                                }}
                            />
                        )
                    }
                    breadcrumbsOnClick={(): void => {
                        dispatch(Push(AutomationPaths.AutomationsList));
                    }}
                    titleSmColumnSizeNumber={10}
                />

                <BasicInfo />
                <Performance />
                <WorkflowEmails />
            </Container>
            {automations && automations.previewTemplate && <Preview />}
        </>
    );
};

export default AutomationReport;
